// extracted by mini-css-extract-plugin
export default {"isMobile":"IsMobile-module--isMobile--bc732"};